import styled from 'styled-components';

import { ButtonSquare } from '@xsolla/ui-core';

export const Wrapper = styled.div`
  display: flex;
`;

export const InputWrapper = styled.div`
  width: 100%;
`;

export const PlusButton = styled(ButtonSquare)`
  margin-left: 8px;
`;
